module.exports = __webpack_public_path__ + "img/ic_nav_kingdom_actived.072c5161.png";